const badgesByPriority = [
  'badgeNew',
  'badgeBestSeller',
  'badgeBestPerformance',
];

export const badgesSortedByPriority = (badgeTypes: string[]) => {
    return badgeTypes.slice().sort((a, b) => {
        const indexA = badgesByPriority.indexOf(a);
        const indexB = badgesByPriority.indexOf(b);

        // If not found in badgesByPriority, treat as lowest priority (put last)
        const priorityA = indexA === -1 ? badgesByPriority.length : indexA;
        const priorityB = indexB === -1 ? badgesByPriority.length : indexB;

        return priorityA - priorityB;
    });
};
